import styled from 'styled-components';

const UploadScormContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

const ProgressBarContainer = styled.div`
  margin-top: 15px;
`;

export {
  UploadScormContainer,
  ProgressBarContainer
}